import { Grid, Stack, Typography } from '@mui/material';
import CustomDateTimeRangePicker from 'common/components/CustomDateTimeRangePicker';
import useFlexBoxStyles from 'common/flexBox';
import { useIncludeDateValidation } from 'common/hooks/useIncludeDateValidation';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const ServicePeriodOfService = ({ fields, handleFieldChange, disabled, timeZone }) => {
    const { t } = useTranslation();
    const { classes: flexBox } = useFlexBoxStyles();
    const { isValidDateRange, error, validationType, setError } = useIncludeDateValidation();
    let dates = fields?.dateRanges || [];
    dates = [...dates].sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

    const handleEditDate = (newDate, idx) => {
        const newRange = [
            ...dates.slice(0, idx),
            {
                ...dates[idx],
                startDate: moment(newDate.start),
                endDate: moment(newDate.end),
            },
            ...dates.slice(idx + 1),
        ];
        saveRange(newRange);
    };

    const handleAddDate = (newDate) => {
        const newRange = [
            ...dates,
            {
                startDate: moment(newDate.start),
                endDate: moment(newDate.end),
                templateId: dates[0]?.templateId,
            },
        ];
        saveRange(newRange);
    };

    const handleDeleteDate = (idx) => {
        const newRange = [...dates.slice(0, idx), ...dates.slice(idx + 1)];
        if (error?.idx === idx) {
            setError(null);
        }
        saveRange(newRange);
    };

    const saveRange = (newRange) => {
        const sortedRange = [...newRange].sort((a, b) => moment(a.startDate).valueOf() - moment(b.startDate).valueOf());
        handleFieldChange({
            target: {
                name: 'dateRanges',
                value: sortedRange,
            },
        });
    };

    const handleChange = (date, idx, callback) => {
        const isValid = isValidDateRange({ ranges: dates, date, idx, type: validationType.UNSELECTED });
        if (isValid) {
            if (idx === -1) {
                handleAddDate(date);
                callback?.();
            } else {
                handleEditDate(date, idx);
            }
        }
    };

    return (
        <Stack direction="column" spacing={1} className={flexBox.paddingTop2}>
            <Grid container>
                <Grid item sm={1.5}>
                    <Typography variant="subtitle2" fontWeight={400} className={flexBox.paddingTop1}>
                        {t('services.form.dateFrom').toUpperCase()}
                    </Typography>
                </Grid>

                <Grid item sm={10.5}>
                    <Stack direction="column" spacing={1}>
                        {dates?.map((date, idx) => (
                                <CustomDateTimeRangePicker
                                    key={`${date.startDate}-${idx}`}
                                    date={{
                                        start: moment(date.startDate).format('YYYY-MM-DDTHH:mm'),
                                        end: moment(date.endDate).format('YYYY-MM-DDTHH:mm'),
                                    }}
                                    dates={dates}
                                    onApply={(date) => handleChange(date, idx)}
                                    onDelete={() => handleDeleteDate(idx)}
                                    error={error?.idx === idx ? error?.msg : null}
                                    disabled={error ? error?.idx !== idx : disabled}
                                ></CustomDateTimeRangePicker>
                            ))
                        }

                        <CustomDateTimeRangePicker
                            onApply={(date) => handleChange(date, -1)}
                            error={error?.idx === -1 ? error?.msg : null}
                            disabled={error ? error?.idx !== -1 : disabled}
                            dates={dates}
                        ></CustomDateTimeRangePicker>
                    </Stack>
                </Grid>
            </Grid>
        </Stack>
    );
};

export default ServicePeriodOfService;
